'use strict';

class MarketplaceNotificationService {

    static showLoading() {
        return Swal.fire({
            title: 'Выполняется расчет...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    }


    static showSuccess(title, message) {
        return Swal.fire({
            title: title,
            text: message,
            icon: 'success'
        });
    }


    static showError(title, message) {
        return Swal.fire({
            title: title,
            text: message,
            icon: 'error'
        });
    }


    static showConfirm(title, message) {
        return Swal.fire({
            title: title,
            text: message,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Да',
            cancelButtonText: 'Нет'
        });
    }


    static close() {
        Swal.close();
    }
}